import { render, staticRenderFns } from "./_6.vue?vue&type=template&id=72924767&"
import script from "./_6.vue?vue&type=script&lang=js&"
export * from "./_6.vue?vue&type=script&lang=js&"
import style0 from "./_6.vue?vue&type=style&index=0&id=72924767&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports